import Vue from 'vue'
import VueRouter from 'vue-router'
import loginPage from '../views/login-page/login-page.vue'
import payPage from '../views/pay-page/pay-page.vue'
import pageBox from '../views/page-box/page-box.vue'
import indexPage from '../views/index-page/index-page.vue'
import interactPage from '../views/interact-page/interact-page.vue'
import surveyPage from '../views/survey-page/survey-page.vue'
import newsPage from '../views/news-page/news-page.vue'
import coursePage from '../views/course-page/course-page.vue'
import sciencePage from '../views/science-page/science-page.vue'
import popularizationPage from '../views/popularization-page/popularization-page.vue'
import memberPage from '../views/member-page/member-page.vue'
import matrixPage from '../views/matrix-page/matrix-page.vue'
import ksglPage from '../views/ksgl-page/ksgl-page.vue'
import ksglfPage from '../views/ksglf-page/ksglf-page.vue'
import associationPage from '../views/association-page/association-page.vue'
import detailPage from '../views/detail-page/detail-page.vue'
import agreementPage from '../views/agreement-page/agreement-page.vue'
import searchPage from '../views/search-page/search-page.vue'
import consultPage from '../views/consult-page/consult-page.vue'

Vue.use(VueRouter)
//push 
const VueRouterPush = VueRouter.prototype.push 
VueRouter.prototype.push = function push (to) {
    return VueRouterPush.call(this, to).catch(err => err)
}
//replace
const VueRouterReplace = VueRouter.prototype.replace
VueRouter.prototype.replace = function replace (to) {
  return VueRouterReplace.call(this, to).catch(err => err)
}
const routes = [
  {
    path: '/',
    redirect: "/pageBox"
  },
  {
    path: '/pageBox',
    name: 'pageBox',
    component: pageBox,
    redirect: "/indexPage",
    children: [
      {
        path: '/indexPage',
        name: 'indexPage',
        component: indexPage,
        meta: {title: '首页'},
      },
      {
        path: '/surveyPage',
        name: 'surveyPage',
        component: surveyPage,
        meta: {title: '协会概况'},
      },
      {
        path: '/newsPage',
        name: 'newsPage',
        component: newsPage,
        meta: {title: '新闻动态'},
      },
      {
        path: '/coursePage',
        name: 'coursePage',
        component: coursePage,
        meta: {title: '课程与活动'},
      },
      {
        path: '/sciencePage',
        name: 'sciencePage',
        component: sciencePage,
        meta: {title: '学术交流'},
      },
      {
        path: '/popularizationPage',
        name: 'popularizationPage',
        component: popularizationPage,
        meta: {title: '科学普及'},
      },
      {
        path: '/memberPage',
        name: 'memberPage',
        component: memberPage,
        meta: {title: '会员中心'},
      },
      {
        path: '/matrixPage',
        name: 'matrixPage',
        component: matrixPage,
        meta: {title: '培训基地管理'},
      },
      {
        path: '/ksglPage',
        name: 'ksglPage',
        component: ksglPage,
        meta: {title: '考生管理'},
      },
      {
        path: '/ksglfPage',
        name: 'ksglfPage',
        component: ksglfPage,
        meta: {title: '考生管理'},
      },
      {
        path: '/associationPage',
        name: 'associationPage',
        component: associationPage,
        meta: {title: '协会党建'},
      },
      {
        path: '/interactPage',
        name: 'interactPage',
        component: interactPage,
        meta: {title: '互动交流'},
      },
      {
        path: '/searchPage',
        name: 'searchPage',
        component: searchPage,
        meta: {title: '搜索'},
      },
      {
        path: '/consultPage',
        name: 'consultPage',
        component: consultPage,
        meta: {title: '咨询详情'},
      },
      
    ]
  },
  {
    path: '/detailPage',
    name: 'detailPage',
    component: detailPage,
    meta: {title: '文章详情'},
  },
  {
    path: '/agreementPage',
    name: 'agreementPage',
    component: agreementPage,
    meta: {title: '协议'},
  },
  {
    path: '/loginPage',
    name: 'loginPage',
    component: loginPage,
    meta: {title: '登录'},
  },
  {
    path: '/payPage',
    name: 'payPage',
    component: payPage,
    meta: {title: '会员费用支付'},
  },
]

const router = new VueRouter({
  mode: 'hash',
  base: process.env.BASE_URL,
  routes
})
router.beforeEach((to, from, next) => {
  if (to.meta.title) {
    document.title = `${Vue.prototype.$wangzhan.name=='安徽'?'安徽省心理学会':Vue.prototype.$wangzhan.name+'心理咨询师协会'}`+(to.meta.title=='首页'?'':' - '+(Vue.prototype.$wangzhan.name=='安徽'?(to.meta.title=='协会概况'?'学会概况':(to.meta.title=='协会党建'?'学会党建':to.meta.title)):to.meta.title))
  }
  next()
})
export default router
